import { ChangeDetectorRef, Component, effect, inject, signal } from '@angular/core';
import { Api } from '../../services/api';
import { toObservable, toSignal } from '@angular/core/rxjs-interop';
import { LocalDataSource, Settings, Angular2SmartTableModule } from 'angular2-smart-table';
import { of, switchMap } from 'rxjs';
import { Loader } from '../../components/loader/loader';
import { NgTemplateOutlet } from '@angular/common';

@Component({
  selector: 'app-particles',
  imports: [Angular2SmartTableModule, Loader, NgTemplateOutlet],
  templateUrl: './particles.html',
  styleUrl: './particles.css',
})
export class Particles {
  private readonly api = inject(Api);
  private readonly cdr = inject(ChangeDetectorRef);

  protected readonly materials = toSignal<Material[] | null>(this.api.getMaterials(), { initialValue: null });
  protected readonly selectedMaterial = signal<Material | null>(null);
  protected readonly particles = toSignal(
    toObservable(this.selectedMaterial).pipe(
      switchMap((material) =>
        material ? this.api.getParticles(material.id, material.version) : of([]),
      ),
    ),
    { initialValue: [] },
  );
  protected readonly source = new LocalDataSource();

  constructor() {
    effect(() => {
      const tableData = this.particles().map((p) => ({
        type: p.shape.type,
        id: p.id,
        material: p.material_id,
        radius: p.shape.layout_table[0]?.physical_radius || 0,
      }));
      this.source.load(tableData);
      queueMicrotask(() => this.cdr.detectChanges());
    });
  }

  protected onMaterialChange(event: Event) {
    const id = (event.target as HTMLSelectElement).value;
    const material = this.materials()?.find((material) => material.id === id);
    if (material) this.selectedMaterial.set(material);
  }

  settings: Settings = {
    actions: false,
    columns: {
      type: { title: 'Type' },
      id: { title: 'Id' },
      material: { title: 'Material' },
      radius: { title: 'Radius' },
    },
  };
}
